import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

import { PureAsyncSearchInput } from 'src/components/Formik/Forms/PureAsyncSearchInput'

import { formatLabelPerson } from 'src/modules/pessoas/utils'
import { formatLabelEndereco } from 'src/modules/pessoas/utils/labelFormatEndereco'

import { LotesFormData } from '../../types'

interface Props {
  isRestrictedEdit: boolean
  grupoNegociadorId: string
}

export const PagadorTomadorFields = ({
  isRestrictedEdit,
  grupoNegociadorId
}: Props) => {
  const { values } = useFormikContext<LotesFormData>()

  const enderecoPagadorTomadorFilters = useMemo(
    () => ({
      pessoaId: values.pagadorTomador?.value
    }),
    [values.pagadorTomador?.value]
  )

  return (
    <>
      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="pagadorTomador"
          label="Pagador/Tomador (opcional)"
          url="/pessoas"
          filters={{
            grupoNegociadorId
          }}
          labelFormat={formatLabelPerson}
          paramSearch="nomeDocumento"
          disabled={isRestrictedEdit || !grupoNegociadorId}
          allowSearchWhenDisabled
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="enderecoPagadorTomador"
          label="Endereço Pagador/Tomador (opcional)"
          url="/enderecos"
          filters={enderecoPagadorTomadorFilters}
          labelFormat={formatLabelEndereco}
          paramSearch="logradouro"
          disabled={!values.pagadorTomador?.value || isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>
    </>
  )
}
